"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSceneObject = exports.SceneObject = void 0;
const MemoizedBoolean_1 = require("./MemoizedBoolean");
const MemoizedString_1 = require("./MemoizedString");
const ObservableEntity_1 = require("./ObservableEntity");
const TransformNode_1 = require("./TransformNode");
class SceneObject extends ObservableEntity_1.ObservableEntity {
}
exports.SceneObject = SceneObject;
function makeSceneObject(id) {
    return new SceneObjectImp(id);
}
exports.makeSceneObject = makeSceneObject;
class SceneObjectImp extends SceneObject {
    constructor(id) {
        super();
        this.memoizedLabel = new MemoizedString_1.MemoizedString("", this.notify);
        this.memoizedEnabled = new MemoizedBoolean_1.MemoizedBoolean(true, this.notify);
        this.transform = TransformNode_1.makeTransformNode();
        this.id = id;
        this.transform.addObserver(this.notify);
    }
    get label() {
        return this.memoizedLabel.val;
    }
    set label(label) {
        this.memoizedLabel.val = label;
    }
    get enabled() {
        return this.memoizedEnabled.val;
    }
    set enabled(enabled) {
        this.memoizedEnabled.val = enabled;
    }
}
